<template>
        <div class="view">
          <v-breadcrumbs>
            <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
              >Home</v-breadcrumbs-item
            >
            <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
            <v-breadcrumbs-item :exact="true" :to="{ name: 'location', params: {} }">
            Location
            </v-breadcrumbs-item>
            <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
            <v-breadcrumbs-item :to="{ name: 'locationView', params: {} }">
              View Location
            </v-breadcrumbs-item>
          </v-breadcrumbs>

          <v-card v-if="loaded">
            <v-card-title>
              View Location
            </v-card-title>
            <v-card-text>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    
          <tr v-if="location.name">
            <td max-width="35%" class="text-subtitle-1">Location Name:</td>
            <td>{{ location.name }}</td>
          </tr>
          
          <tr v-if="location.codeName">
            <td max-width="35%" class="text-subtitle-1">Code Name:</td>
            <td>{{ location.codeName }}</td>
          </tr>
          
          <tr v-if="location.code">
            <td max-width="35%" class="text-subtitle-1">Code:</td>
            <td>{{ location.code }}</td>
          </tr>
          
          <tr v-if="location.lat">
            <td max-width="35%" class="text-subtitle-1">Location Latitude:</td>
            <td>{{ location.lat }}</td>
          </tr>
          
          <tr v-if="location.lng">
            <td max-width="35%" class="text-subtitle-1">Location Longitude:</td>
            <td>{{ location.lng }}</td>
          </tr>
          
          <tr v-if="location.email">
            <td max-width="35%" class="text-subtitle-1">Email:</td>
            <td>{{ location.email }}</td>
          </tr>
          
          <tr v-if="location.phoneNumber">
            <td max-width="35%" class="text-subtitle-1">Phone Number:</td>
            <td>{{ location.phoneNumber }}</td>
          </tr>
          
          <tr v-if="location.address">
            <td max-width="35%" class="text-subtitle-1">Address:</td>
            <td>{{ location.address }}</td>
          </tr>
          
          <tr v-if="location.receiptHeader">
            <td max-width="35%" class="text-subtitle-1">Receipt Header:</td>
            <td>{{ location.receiptHeader }}</td>
          </tr>
          
          <tr v-if="location.invoiceHeader">
            <td max-width="35%" class="text-subtitle-1">Invoice Header:</td>
            <td>{{ location.invoiceHeader }}</td>
          </tr>
          
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>

          <div class="d-flex justify-space-between ma-5">
            <v-btn @click="goBack">Back</v-btn>
            <v-btn @click="edit(id)" color="primary">Edit</v-btn>
            <span></span>
          </div>
      </div>
    </template>

    <script>
    import { getLocation } from "@/services/location";
    

    export default {
      data() {
        return {
            id: '',
            location: {},
            loaded: false,
            relations: {}
        }
      },
      methods : {
        goBack() {
          this.$router.go(-1);
        },
        edit(id) {
          this.$router.push({ name: "locationEdit", params: { id: id }});
        },
        setInstance() {
          this.setDependencies().then( () => {
            getLocation(this.id)
            .then((response) => {
              this.location = response.data;
              this.loaded = true;
            })
            .catch( () => {
              this.addErrorMessage("Error loading location");
              this.loaded = true;
            });
          })
        },
        async setDependencies() {
          return null;
        },
        getRelationText(id, relationProperty, relationAttribute) {
          const relationList = this.relations[relationProperty];
          if (relationList) {
            const relationObj = relationList.find(r => r.id == id);
            return relationObj[relationAttribute];
          } else {
            return "";
          }
        }
      },
      created() {
        this.id = this.$route.params.id;
        this.setInstance();
        this.$emit("showParent", false);
      }
    }
    </script>
    